import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UseraccessserviceService } from 'src/app/services/useraccessservice.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { ComponentheaderService } from 'src/app/services/componentheader.service';

@Component({
  selector: 'app-changepassword',
  templateUrl: './changepassword.component.html',
  styleUrls: ['./changepassword.component.css']
})
export class ChangepasswordComponent implements OnInit {

  successMessage: string;
  errorMessage: string;
  isLoading: boolean;
  code: string;
  oldPassword: string;
  newPassword: string;
  newPasswordConfirm: string;

  constructor(private activatedrouter: ActivatedRoute, private resetService: UseraccessserviceService, private toastr: ToastrService, private router: Router, private headerinfo: ComponentheaderService) {
    this.headerinfo.setHeaderDisplay('Change Password', [], []);
  }

  ngOnInit(): void {
    this.code = this.activatedrouter.snapshot.queryParams.code;
    this.headerinfo.setPageTitle('Change Password');
    //debugger;
  }


  async OnSubmit() {
    if (this.newPassword != this.newPasswordConfirm) {
      this.toastr.error("Password Mismatch");
    }
    else {
      this.isLoading = true;

      const notifyPasswordNotGloballyChanged = (data: any) => {
        if(data.topLevelUserExists){
          this.toastr.warning("Please note that the password change only applies to the account for this school", undefined, { timeOut: 0, closeButton: true});
        }
      }
      try{
        if(!this.code){//that means this is coming from change password
          const data: any = await this.resetService.passwordupdate(this.newPassword, this.oldPassword).toPromise().finally(() => { this.isLoading = false });
          if (data) {
            this.toastr.success("Password Reset Successful");
            notifyPasswordNotGloballyChanged(data);
            this.router.navigate(['/user/dashboard']);
          }
        }
        else{//that means the user got here by clicking the forgot password link
          const data: any = await this.resetService.forgotPasswordReset(this.code, this.newPassword).toPromise().catch((err) => { debugger; console.log(err) }).finally(() => { this.isLoading = false });
          if (data) {
            this.toastr.success("Password Reset Successful");
            notifyPasswordNotGloballyChanged(data);
            this.router.navigate(['/access/login']);
          }
        }
      }
      catch(err){
        console.log(err);
        this.toastr.error("Error While Resetting password");
      }
    }
    // subscribe(
    //   (data : any)=>{     
    //      this.successMessage = data;   
    //      this.isLoading = false;
    //   },
    //   (err : HttpErrorResponse) => {   
    //       if(err.status === 0){
    //         this.errorMessage = err.error.message;
    //       }
    //       else if(err.status === 400){
    //         this.errorMessage = err.error.message;
    //       }
    //       this.isLoading = false;
    //   }
    // );

  }


}
